import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BrowserUtils } from "@azure/msal-browser";
import { MsalGuard } from "@azure/msal-angular";
import { SchedulingComponent } from './scheduling/scheduling.component';
import { ContractsComponent } from './contracts/contracts.component';
import { TruckersComponent } from './truckers/truckers.component';
import { LoadBankComponent } from './load-bank/load-bank.component'; 
import { ScheduleMobileComponent } from './mobile-screens/schedule-mobile/schedule-mobile.component';
import { ViewDispatchComponent } from './mobile-screens/view-dispatch/view-dispatch.component';
import { LoadUnloadComponent } from './mobile-screens/load-unload/load-unload.component';  
import { AlertTruckersFilterComponent } from './mobile-screens/alert-truckers-filter/alert-truckers-filter.component';
import { TruckerConfirmReportComponent } from './trucker-confirmation/trucker-confirm-report.component';
import { LocationConfirmReportComponent } from './location-confirmation/location-confirm-report.component';
import { TicketMaintenanceComponent } from './ticket-maintenance/ticket-maintenance.component';
import { ScaleViewComponent } from './scale-view/scale-view.component';
import { roleGuard } from './services/role.guard';
import { compuweighGuard } from './services/compuweigh.guard';
import { AdminConfigComponent } from './admin-config/admin-config.component';
import { AcsUserManagementComponent } from './admin-config/acs-user-management/acs-user-management.component';
import { AcsTradeUnitDefaultComponent } from './admin-config/acs-trade-unit-default/acs-trade-unit-default.component';
import { AcsLocationNotesComponent } from './admin-config/acs-location-notes/acs-location-notes.component';
import { AcsElevatorMatchComponent } from './admin-config/acs-elevator-match/acs-elevator-match.component';
import { AcsBillAddressComponent } from './admin-config/acs-bill-address/acs-bill-address.component';
import { AcsDeleteCustomerComponent } from './admin-config/acs-delete-customer/acs-delete-customer.component';
import { AcsVariableWeightComponent } from './admin-config/acs-variable-weight/acs-variable-weight.component';
import { AcsTradeUnitGroupsComponent } from './admin-config/acs-trade-unit-groups/acs-trade-unit-groups.component';
import { AcsTradeUnitCommodityComponent } from './admin-config/acs-trade-unit-commodity/acs-trade-unit-commodity.component';
import { ScoutAiPopoutComponent } from './scout-ai/scout-ai-popout.component';

const routes: Routes = [
    //this will default the root path to the scheduling page/component but then requires authentication so will auto login and not show the login link
    { path: '', redirectTo: 'scheduling', pathMatch: 'full' },
    { path: 'scheduling', component: SchedulingComponent, canActivate: [MsalGuard, roleGuard] },
    { path: 'contracts', component: ContractsComponent, canActivate: [MsalGuard, roleGuard] },
    { path: 'load-bank', component: LoadBankComponent, canActivate: [MsalGuard, roleGuard] },
    { path: 'ticket-maintenance', component: TicketMaintenanceComponent, canActivate: [MsalGuard, roleGuard] },
    { path: 'scale-view', component: ScaleViewComponent, canActivate: [MsalGuard, compuweighGuard] },
    { path: 'truckerconfirmreport/:id/:breakout', component: TruckerConfirmReportComponent, canActivate: [MsalGuard, roleGuard] },
    { path: 'locationconfirmreport/:lt/:loc/:start/:end/:id/:bbd/:udd/:sc/:st/:sl/:scs/:sln/:scust/:hut/:slnum/:sdrv/:splt', component: LocationConfirmReportComponent, canActivate: [MsalGuard, roleGuard] },
    { path: 'truckers', component: TruckersComponent, canActivate: [MsalGuard, roleGuard] },
    {
      path: 'admin-config',
      component: AdminConfigComponent,
      canActivate: [MsalGuard],
      children: [
        { path: '', redirectTo: 'bill-address', pathMatch: 'full' },
        { path: 'bill-address', component: AcsBillAddressComponent },
        { path: 'delete-customer', component: AcsDeleteCustomerComponent },
        { path: 'elevator-match', component: AcsElevatorMatchComponent },
        { path: 'trade-unit-commodities', component: AcsTradeUnitCommodityComponent },
        { path: 'trade-unit-default', component: AcsTradeUnitDefaultComponent },
        { path: 'location-notes', component: AcsLocationNotesComponent },
        { path: 'trade-unit-groups', component: AcsTradeUnitGroupsComponent },
        { path: 'user-management', component: AcsUserManagementComponent },
        { path: 'variable-weight', component: AcsVariableWeightComponent },
      ]
    },
    { path: 'schedule-mobile', component: ScheduleMobileComponent },
    { path: 'view-dispatch/:id', component: ViewDispatchComponent },
    { path: 'load-unload', component: LoadUnloadComponent }, 
    { path: 'alert-truckers-filter/:id', component: AlertTruckersFilterComponent },
    { path: 'scout-ai-popout', component: ScoutAiPopoutComponent, canActivate: [MsalGuard] }
];

const isIframe = window !== window.parent && !window.opener;

@NgModule({
  imports: [
        RouterModule.forRoot(routes, {
            useHash: window.location.hostname === "localhost",
      // Don't perform initial navigation in iframes or popups
      initialNavigation:
        !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup()
          ? "enabledNonBlocking"
          : "disabled", // Set to enabledBlocking to use Angular Universal
    }),
  ],
  exports: [RouterModule],
})

export class AppRoutingModule { }